import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary-300/60 bg-primary-50 mb-5">
            <span className="text-xs font-medium text-primary-700">Common Questions</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Everything you need to know about using LitBuy spreadsheets effectively
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
                >
                  <h4 className="text-sm font-semibold text-foreground-900 pr-2">
                    {item.question}
                  </h4>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-sm text-foreground-500"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}